import http from '../../../services/httpService'
import UnexpectedStockOutflow from '../domain/UnexpectedStockOutflow'
import UnexpectedStockOutflowRepository from '../domain/unexpectedStockOutflowRepository'

export default class RemoteUnexpectedStockOutflowRepository extends UnexpectedStockOutflowRepository {
  async create(data) {
    try {
      const { data: response } = await http.post('/unexpected-outflows', data)
      if (response.success) {

        const adjuntos = response.data?.adjuntos.map(adjunto => {
          const partes = adjunto.uri.split('/');
          const nombreArchivo = partes[partes.length - 1];
          return ({
          path: adjunto.uri,
          basename: nombreArchivo,
          toMove: false,
        })})
        return UnexpectedStockOutflow.fromPrimitives({...response.data, adjuntos})
      }
      throw new Error(response.message || 'Error al crear la salida extraordinaria')
    } catch (error) {
      throw new Error(error.message || 'Error al crear la salida extraordinaria')
    }
  }

  async upload(file) {
    try {
      const formData = new FormData()
      formData.append('file', file)

      const { data: response } = await http.post('/unexpected-outflows/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      if (response.success) {
        return response.data.uploaded_file
      }
      throw new Error(response.message || 'Error al subir el archivo')
    } catch (error) {
      throw new Error(error.message || 'Error al subir el archivo')
    }
  }

  async get(id) {
    try {
      const { data: response } = await http.get(`/unexpected-outflows/${id}`)
      if (response.success) {
        const adjuntos = response.data?.adjuntos.map(adjunto => {
          const partes = adjunto.uri.split('/');
          const nombreArchivo = partes[partes.length - 1];
          return ({
          path: adjunto.uri,
          basename: nombreArchivo,
          toMove: false,  
        })})
        return UnexpectedStockOutflow.fromPrimitives({...response.data, adjuntos})
      }
      throw new Error(response.message || 'Error al obtener la salida extraordinaria')
    } catch (error) {
      throw new Error(error.message || 'Error al obtener la salida extraordinaria')
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await http.put(`/unexpected-outflows/${id}`, data)
      if (response.success) {
        const adjuntos = response.data?.adjuntos.map(adjunto => {
          const partes = adjunto.uri.split('/');
          const nombreArchivo = partes[partes.length - 1];
          return ({
          path: adjunto.uri,
          basename: nombreArchivo,
          toMove: false,
        })})
        return UnexpectedStockOutflow.fromPrimitives({...response.data, adjuntos})
      }
      throw new Error(response.message || 'Error al actualizar la salida extraordinaria')
    } catch (error) {
      throw new Error(error.message || 'Error al actualizar la salida extraordinaria')
    }
  }

  async delete(id) {
    try {
      const { data: response } = await http.delete(`/unexpected-outflows/${id}`)
      if (response.success) {
        return true
      }
      throw new Error(response.message || 'Error al eliminar la salida extraordinaria')
    } catch (error) {
      throw new Error(error.message || 'Error al eliminar la salida extraordinaria')
    }
  }

  async getByProduct(productId) {
    try {
      const { data: response } = await http.get(`/unexpected-outflows/find-by-product/${productId}`)
      if (response.success) {
        return response.data.map(outflow => {
          const adjuntos = outflow?.adjuntos?.map(adjunto => {
            const partes = adjunto.uri.split('/');
            const nombreArchivo = partes[partes.length - 1];
            return ({
              path: adjunto.uri,
              basename: nombreArchivo,
              toMove: false,
            })
          }) || []
          return { ...outflow, adjuntos }
        })
      }
      throw new Error(response.message || 'Error al obtener las salidas inesperadas por producto')
    } catch (error) {
      throw new Error(error.message || 'Error al obtener las salidas inesperadas por producto')
    }
  }

  async getDistinctProducts() {
    try {
      const { data: response } = await http.get('/unexpected-outflows/distinct-products')
      if (response.success) {
        return response.data.map(product => ({
          idProducto: product.idProducto,
          concepto: product.concepto,
        }))
      }
      throw new Error(response.message || 'Error al obtener la lista de productos de salidas inesperadas')
    } catch (error) {
      throw new Error(error.message || 'Error al obtener la lista de productos de salidas inesperadas')
    }
  }

  async findByProduct(idProducto, fechaInicio, fechaFin) {
    try {
      const { data: response } = await http.get(`/unexpected-outflows/by-product/${idProducto}`, {
        params: {
          fechaInicio,
          fechaFin
        }
      })
      if (response.success) {
        return response.data.map(outflow => {
          const adjuntos = outflow?.adjuntos?.map(adjunto => {
            const partes = adjunto.uri.split('/');
            const nombreArchivo = partes[partes.length - 1];
            return ({
              path: adjunto.uri,
              basename: nombreArchivo,
              toMove: false,
            })
          }) || []
          return { ...outflow, adjuntos, producto: outflow.concepto }
        })
      }
      throw new Error(response.message || 'Error al obtener las salidas inesperadas del producto')
    } catch (error) {
      throw new Error(error.message || 'Error al obtener las salidas inesperadas del producto')
    }
  }
} 